<script>
  // An <iframe> authenticated by the session cookie instead of a token in its
  // URL. It mounts only once the cookie is set for this tab's contract and is
  // unmounted when another tab takes the cookie over, so nothing inside it runs
  // against the wrong contract or user. Token renewals keep it mounted.
  import sessionCookie from "../services/sessionCookie";

  /** Same-origin URL to embed. */
  export let src;
  /** Accessible name of the frame. */
  export let title;

  const { state } = sessionCookie;

  let mounted = false;
  $: if ($state === "ready") mounted = true;
  $: if ($state === "stale") mounted = false;
</script>

{#if mounted}
  <iframe {src} {title} {...$$restProps} />
{:else}
  <slot name="placeholder" state={$state} />
{/if}
